import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import localization from "../../data/config";
import { ALL_PAGE_SIZES } from "../../constants/config/parts";
import { setPageSize as setPageSizeAction } from "../../actions/parts";
import dropDownArrowIcon from "../../img/icons/dropdown-arrow-pagination.svg";



function TableCount(props) {
    const dispatch = useDispatch(),
        { pageSize, count, resultPerPageLabel } = useSelector((state) => ({
            pageSize: state.parts.pageSize,
            count: state.parts.count,
            resultPerPageLabel: state.labels.resultPerPage
        })),
        [isOpen, setIsOpen] = useState(false),
        dropdownContainerRef = useRef(),
        options = ALL_PAGE_SIZES.filter((size,index) => ALL_PAGE_SIZES[index === 0 ? 0 : index - 1] < count);

    //useEffect to handle the closing of the dropdown on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    /**
   * @name handleToggle
   * @function
   * @description handles the open and closed state of dropdown 
   */
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    /**
   * @name handleDropDownClick
   * @function
   * @description handles click event of dropdown inside input tag
   */
    const handleDropDownClick = (option) => {
        dispatch(setPageSizeAction(option));
        setIsOpen(false);
    };

    return (
        <div className="pagination_nav-flex">
            <p>{resultPerPageLabel}</p>
            <div className="input-container" ref={dropdownContainerRef}>
                <div onClick={handleToggle}>
                    <input
                        type="text"
                        value={pageSize}
                        className="page-input"
                        aria-label={localization.pageInput}
                        tabIndex={0}
                        aria-expanded={`${isOpen ? "true" : "false"}`}
                        role="combobox"
                        aria-autocomplete="list"
                        readOnly
                    />
                    <img
                        className={`dropdown-icon ${isOpen ? "open" : ""}`}
                        src={dropDownArrowIcon}
                        alt="dropdown-icon"
                        width="24px"
                        height="24px"
                    />
                </div>

                {isOpen && (
                    <ul className="dropdown-options-pagination">
                        {options.map((option, index) => (
                            <li
                                className="dropdown-options-pagination__option"
                                tabIndex={0}
                                onClick={() => handleDropDownClick(option)}
                            >
                                {option}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    )
}

export default TableCount;